import { useTranslation } from 'react-i18next';
import type { Item } from 'src/lib/api/types/items';
import type {
  ItemStatusOption,
  ItemTypeLevelOption,
  ItemTypeOption,
} from 'src/lib/api/types/roadmapping';
import {
  useColorLegendPopover,
  VisualizationColorLegendPopover,
} from '@/components/views/utils/visualization-colors';
import { useTimelineColorContext } from './useTimelineColorContext';

export function TimelineColorLegendPopover({
  items,
  itemTypes,
  itemLevels,
  itemStatuses,
}: {
  items: Item[];
  itemTypes: ItemTypeOption[];
  itemLevels: ItemTypeLevelOption[];
  itemStatuses: ItemStatusOption[];
}) {
  const { t } = useTranslation();
  const noValueLabel = t('roadmapping.layout.formatPanel.colors.noValue');

  const context = useTimelineColorContext({
    items,
    itemTypes,
    itemLevels,
    itemStatuses,
    noValueLabel,
  });
  const { legendItems, colorByFieldLabel, shouldRender } = useColorLegendPopover(context);

  if (!shouldRender) return null;

  return <VisualizationColorLegendPopover items={legendItems} title={colorByFieldLabel} />;
}
